module.exports = __webpack_public_path__ + "img/ewm-icon.8f328269.svg";